import {
  getQuoteFromStorage,
  getAuthFromStorage,
  getCurrentAccountFromStorage,
} from 'connectors/storage';

import { currentQuoteState, authenticationState, currentAccountState } from './atoms';

export const initializeState = ({ set }) => {
  set(currentQuoteState, getQuoteFromStorage());
  set(authenticationState, getAuthFromStorage());
  set(currentAccountState, getCurrentAccountFromStorage());
};
